import React from 'react';

import { StyleRulesTable } from 'components/modules/style-rules/components';
import AddStyleRuleButton from 'components/modules/style-rules/components/AddStyleRuleButton';

import './ActiveStyleRulesTab.scss';

const propTypes = {};

const defaultProps = {};

export default function ActiveStyleRulesTab() {
  return (
    <div className="active-style-rules-tab">
      <div>
        <AddStyleRuleButton />
      </div>
      <StyleRulesTable />
    </div>
  );
}

ActiveStyleRulesTab.propTypes = propTypes;
ActiveStyleRulesTab.defaultProps = defaultProps;
